import { FC, useEffect, useMemo, useState, CSSProperties, } from "react";
// 组件
import { ProSpin } from '../antd';
import CardItem from './cardItem';
import AddCardItem from './addCardItem';
// 常量
import { SUCCESS_STATUS_CODE } from "../constants/constant";
import { CardListProps } from "./interface";
import './style.less';

/** 卡片列表 */
const CardList: FC<CardListProps> = props => {
  const {
    dataSource, titleKey, subTitleKey, imageKey, col, cardItemKey, codeKey, actionRef,
    dataKey, params, iconOperation, afterOperation, beforeOperation, isAdd, addIcon, addText,
    fetchApi, onBefore, postData, onClickOperation, onAdd,
  } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [cardData, setCardData] = useState<any[]>(); // 卡片列表数据
  useEffect(() => {
    if (dataSource === undefined) return;
    setCardData(dataSource);
  }, [dataSource]);
  useEffect(() => {
    handleFetch();
  }, []);
  const handleFetch = async () => {
    if (dataSource) return;
    if (!fetchApi) {
      console.error('dataSource和fetchApi至少需要传一个');
      return;
    }
    let listParams: any = params;
    if (onBefore) {
      listParams = await onBefore(params);
      if (listParams === false) return;
    }
    setLoading(true);
    const res = await fetchApi(listParams);
    setLoading(false);
    if (res.code === SUCCESS_STATUS_CODE) {
      const data = res.data;
      let newCardData: any[] = data;
      if (data) {
        let result = (dataKey ? data[dataKey] : data) ?? [];
        if (postData) {
          newCardData = postData ? postData(result, listParams) : result;
        }
        setCardData(newCardData);
      }
    }
  };
  const cardItemStyle: CSSProperties = useMemo(() => {
    if (!col) return { width: '100%', };
    return {
      width: `${(1 / col) * 100}%`,
    };
  }, [col]);
  if (actionRef) {
    actionRef.current = {
      reload: handleFetch,
    };
  }
  return (
    <ProSpin spinning={loading}>
      <div className="yb-card-list">
        {
          cardData?.map((item, index) => {
            return (
              <CardItem
                key={item[cardItemKey || 'key'] || index}
                index={index}
                style={cardItemStyle}
                record={item}
                titleKey={titleKey}
                subTitleKey={subTitleKey}
                imageKey={imageKey}
                codeKey={codeKey}
                iconOperation={iconOperation}
                afterOperation={afterOperation}
                beforeOperation={beforeOperation}
                onClickOperation={onClickOperation}
              />
            );
          })
        }
        {
          isAdd && (
            <AddCardItem
              style={cardItemStyle}
              addIcon={addIcon}
              addText={addText}
              onAdd={onAdd}
            />
          )
        }
      </div>
    </ProSpin>
  );
};

CardList.defaultProps = {
  col: 4,
  titleKey: 'title',
  subTitleKey: 'subTitle',
  cardItemKey: 'key',
  isAdd: true,
};

export default CardList;
